import { History, Loader2, LogOut, Pencil, Save, X } from 'lucide-react';
import { useSiteEditor } from '@/contexts/SiteEditorContext';

/** الشريط اللي بيظهر للأدمن تحت الصفحة: تعديل / حفظ / إلغاء */
const EditBar = ({ page }) => {
  const { admin, exit, panelUrl } = useSiteEditor();
  if (!page.canEdit || !page.data) return null;

  const { editing, dirty, saving } = page;

  return (
    <div
      dir="rtl"
      className="fixed bottom-5 left-1/2 -translate-x-1/2 z-[60] max-w-[calc(100vw-2rem)] flex flex-wrap items-center justify-center gap-2 rounded-2xl bg-gray-900/95 text-white shadow-2xl backdrop-blur px-3 py-2 font-cairo text-sm"
    >
      {editing ? (
        <>
          <span className="flex items-center gap-2 px-2">
            <span className={`w-2 h-2 rounded-full ${dirty ? 'bg-amber-400' : 'bg-emerald-400'}`} />
            {dirty ? 'تعديلات غير محفوظة' : 'وضع التعديل'}
          </span>
          <button
            type="button"
            onClick={page.save}
            disabled={saving || !dirty}
            className="inline-flex items-center gap-1.5 rounded-xl bg-burgundy-500 hover:bg-burgundy-600 disabled:opacity-50 px-4 py-2 font-semibold transition"
          >
            {saving ? <Loader2 className="w-4 h-4 animate-spin" /> : <Save className="w-4 h-4" />}
            حفظ ونشر
          </button>
          <button
            type="button"
            onClick={page.cancel}
            disabled={saving}
            className="inline-flex items-center gap-1.5 rounded-xl hover:bg-white/10 px-3 py-2 transition"
          >
            <X className="w-4 h-4" />
            إلغاء
          </button>
        </>
      ) : (
        <>
          <span className="px-2 text-white/70">
            أهلاً {admin?.name}
          </span>
          <button
            type="button"
            onClick={page.startEditing}
            className="inline-flex items-center gap-1.5 rounded-xl bg-burgundy-500 hover:bg-burgundy-600 px-4 py-2 font-semibold transition"
          >
            <Pencil className="w-4 h-4" />
            تعديل الصفحة
          </button>
          <a
            href={panelUrl}
            target="_blank"
            rel="noopener noreferrer"
            title="سجل النسخ والاسترجاع"
            className="inline-flex items-center gap-1.5 rounded-xl hover:bg-white/10 px-3 py-2 transition"
          >
            <History className="w-4 h-4" />
            السجل
          </a>
          <button
            type="button"
            onClick={exit}
            title="إخفاء أدوات التعديل على هذا الجهاز"
            className="inline-flex items-center justify-center rounded-xl hover:bg-white/10 w-9 h-9 transition"
          >
            <LogOut className="w-4 h-4" />
          </button>
        </>
      )}
    </div>
  );
};

export default EditBar;
